var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 127,
    viewBox: "0 0 319 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2703 103.243C54.9634 78.7699 86.9074 84.5967 93.3806 103.243C100.48 95.0851 143.439 93.5793 141.963 123.249C111.27 128.25 31.4211 128.25 0.728569 123.249C-5.09028 110.672 25.3138 88.093 43.2703 103.243Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.442 15.4305C235.641 -7.81856 266.235 -2.28309 272.435 15.4304C279.234 7.68081 320.378 6.25038 318.964 34.4364C289.569 39.1879 213.093 39.1879 183.698 34.4364C178.125 22.4884 207.244 1.0383 224.442 15.4305Z",
    fill: "url(#paint1_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 14.4796,
    y1: 87,
    x2: 14.4796,
    y2: 118.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 196.868,
    y1: -0.00000475,
    x2: 196.868,
    y2: 30.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaven);
export default __webpack_public_path__ + "static/media/heaven.b213fd160211913a660cde93524ce946.svg";
export { ForwardRef as ReactComponent };